import React from 'react';
import { Modal } from 'hyperdb-utils';
import { HyperdbForm } from '../../../../hyperdb';
import ManagementTab from '../components/ManagementTab';
import DetailsTab from '../components/DetailsTab';
import RentalRulesetTab from '../components/RentalRulesetTab';
import ExportTab from '../components/ExportTab';
import ContentForm from '../../../content/property-content/containers/Form';
import EmailDataForm from '../../../email/property-data/containers/Form';
import { DEFAULT_LANGUAGE } from '../../../../../config';

class EditForm extends React.Component {
  constructor(props) {
    super(props);
    this.handleChange = this.handleChange.bind(this);
    this.handleChangeLocalized = this.handleChangeLocalized.bind(this);
    this.handleChangeRelation = this.handleChangeRelation.bind(this);
    this.handleClickCheckbox = this.handleClickCheckbox.bind(this);
    this.toggleModalCreateOwner = this.toggleModalCreateOwner.bind(this);
    this.handleOwnerCreated = this.handleOwnerCreated.bind(this);
    this.toggleModalCreateGroup = this.toggleModalCreateGroup.bind(this);
    this.handleGroupCreated = this.handleGroupCreated.bind(this);
    this.onRelationsFormChanged = this.onRelationsFormChanged.bind(this);
    this.closeWarningModal = this.closeWarningModal.bind(this);
  }
  componentDidMount() {
    this.props.api.property.setData({ selectedScreen: 'management'});
    this.fetchGroups();
    this.fetchOwners();
    if (!this.props.objectData.source_channel_id.value[1]) {
      this.props.api.channel.getObjects({
        propName: 'property_channels',
        queryOptions: [['name', 'protocol'], { order: { name: 'asc' }, where: { type: 'output' } }],
      });
    }
    // For prices tab
    this.props.api.rentalRuleset.setData({
      editedCapacity: { standard_capacity: this.props.objectData.standard_capacity, maximum_capacity: this.props.objectData.maximum_capacity }
    });
  }

  render() {
    return (
      <div>
        <ManagementTab
          { ...this.props }
          show={ this.props.selectedScreen === 'management' }
          onChange={ this.handleChange.bind(this, 'Management') }
          onChangeRelation={ this.handleChangeRelation.bind(this, 'Management') }
          onClickCheckbox={ this.handleClickCheckbox.bind(this, 'Management') }
          owners={ this.props.api.getState('owner').property_owners }
          toggleModalCreateOwner={ this.toggleModalCreateOwner }
          onOwnerCreated={ this.handleOwnerCreated }
          groups={ this.props.api.getState('propertyGroup').property_groups }
          toggleModalCreateGroup={ this.toggleModalCreateGroup }
          onGroupCreated={ this.handleGroupCreated }
        />
        <DetailsTab
          { ...this.props }
          show={ this.props.selectedScreen === 'details' }
          onChange={ this.handleChange }
          defaultLanguage={ this.props.defaultLanguage }
          availableLanguages={ this.props.availableLanguages } />
        <RentalRulesetTab
          show={ this.props.selectedScreen === 'prices_conditions' }
          id={ this.props.objectData.daily_rental_ruleset.value[1] }
          property={ this.props.objectData }
          onChange={ this.onRelationsFormChanged }
          onChangePropertyFields={ this.handleChange.bind(this, 'Features') } />
        <ContentForm
          show={ this.props.selectedScreen === 'content' }
          id={ this.props.objectData.content.value[1] }
          propertyId={ this.props.objectData.id }
          onChange={ this.onRelationsFormChanged }
          defaultLanguage={ this.props.defaultLanguage }
          availableLanguages={ this.props.availableLanguages } />
        <EmailDataForm
          show={ this.props.selectedScreen === 'email_data' }
          id={ this.props.objectData.email_data.value[1] }
          propertyId={ this.props.objectData.id }
          onChange={ this.onRelationsFormChanged }
          defaultLanguage={ this.props.defaultLanguage }
          availableLanguages={ this.props.availableLanguages } />
        {
          !this.props.objectData.source_channel_id.value[1]
            ? <ExportTab
                { ...this.props }
                show={ this.props.selectedScreen === 'export' }
                channels={ this.props.api.getState('channel').property_channels || [] }
                onChange={ this.handleChange.bind(this, 'Export') } />
            : null
        }
        {
          this.props.showWarningModal
            ? <Modal title="Property not valid" onClose={ this.closeWarningModal } onAccept={ submit.bind(null, this.props, false) } labelCancel="Cancel" labelAccept="Save">
                <span className="text-danger"><i className="fas fa-warning"/> Warning. The following fields are not valid, the property will then not be active:</span>
                <br/><br/>
                <ul>
                  {
                    this.props.fieldsInError.map((field, i) => {
                      return (
                        <li key={ i }>{ displayErrorMessage(field) }</li>
                      );
                    })
                  }
                </ul>
                <br/>
                Do you still want to save ?
              </Modal>
            : null
        }
      </div>
    );
  }

  onRelationsFormChanged() {
    if (!this.props.formChanged) {
      this.props.api.property.setData({ formChanged: true });
    }
  }

  handleChange(tab, attributeName, field) {
    const { name, value } = field;
    this.props.api.property.updateEditedObject({ attributeName, value });
    this.setSynchronisation(tab, attributeName, value);
    // For prices tab
    if (['standard_capacity', 'maximum_capacity'].includes(attributeName)) {
      const { editedCapacity } = this.props.api.getState('rentalRuleset');
      editedCapacity[attributeName] = value;
      this.props.api.rentalRuleset.setData({ editedCapacity });
    }
  }
  handleChangeLocalized(tab, attributeName, field) {
    const { name, value } = field;
    this.handleChange(tab, attributeName, { value: { $i18n: value } });
  }
  handleChangeRelation(tab, attributeName, field) {
    const { name, value } = field;
    const reference = { ...this.props.objectData[attributeName] };
    reference.value[1] = value;
    this.handleChange(tab, attributeName, { value: reference });
  }
  handleClickCheckbox(tab, attributeName) {
    const value = !this.props.objectData[attributeName];
    this.handleChange(tab, attributeName, { value });
  }

  setSynchronisation(tab, attributeName, value) {
    if (!this.props.objectData.source_channel_id.value[1]) {
      if (['Presentation', 'Location', 'Features'].includes(tab)) {
        const synchronisation = { ...this.props.objectData.synchronisation || {} };
        synchronisation.parameters = synchronisation.parameters || { action: 'push', data: {} };
        synchronisation.parameters.data[attributeName] = value;
        this.props.api.property.updateEditedObject({ attributeName: 'synchronisation', value: synchronisation });
      }
    }
  }

  fetchGroups() {
    this.props.api.propertyGroup.getObjects({
      propName: 'property_groups',
      queryOptions: [['id', 'name'], { order: { name: 'asc' } }],
    });
  }
  fetchOwners() {
    this.props.api.owner.getObjects({
      propName: 'property_owners',
      queryOptions: [['id', 'name'], { order: { name: 'asc' } }],
    });
  }

  toggleModalCreateGroup(bool) {
    this.props.api.property.setData({ showModalGroup: bool });
  }
  handleGroupCreated(groupId) {
    this.fetchGroups();
    this.handleChangeRelation('Management', 'group', { value: groupId });
    this.toggleModalCreateGroup(false);
  }
  toggleModalCreateOwner(bool) {
    this.props.api.property.setData({ showModalOwner: bool });
  }
  handleOwnerCreated(ownerId) {
    this.fetchOwners();
    this.handleChangeRelation('Management', 'owner', { value: ownerId });
    this.toggleModalCreateOwner(false);
  }

  closeWarningModal() {
    this.props.api.property.setData({ showWarningModal: false });
  }
}

const AdditionalHeaders = (props) => {
  const handleSelect = (evt) => {
    props.api.property.setData({ selectedScreen: evt.target.value });
  };
  return (
    <select className="form-control property-screen-selector" value={ props.selectedScreen } onChange={ handleSelect }>
      <option value="management">Management</option>
      <option value="details">Details</option>
      <option value="prices_conditions">Prices and conditions</option>
      <option value="content">Web page</option>
      <option value="email_data">Email data</option>
      {
        !props.objectData.source_channel_id || !props.objectData.source_channel_id.value[1]
          ? <option value="export">Export</option>
          : null
      }
    </select>
  );
};

EditForm.propTypes = {
  api: React.PropTypes.object,
  objectData: React.PropTypes.object,
  availableLanguages: React.PropTypes.array,
  defaultLanguage: React.PropTypes.string,
};

export default HyperdbForm(EditForm, {
  namespace: 'property',
  mountedUrl: '/properties',
  titleEdit: 'Edit property',
  displayName: (object) => object.name,
  AdditionalHeaders,
  onSubmit: (props) => {
    const property = props.objectData;
    const rentalRuleset = props.api.getState('rentalRuleset').objectData;
    const fieldsInError = checkIsValid(property, rentalRuleset);
    if (fieldsInError.length > 0) {
      props.api.property.setData({ fieldsInError, showWarningModal: true });
    } else {
      submit(props, true);
    }
  },
  backUrl: (props) => {
    if (!window.previousLocation || window.previousLocation.includes('/properties/new')) return '/properties';
    const relativeUrl = window.previousLocation.split('/').slice(2).join('/');
    return '/' + relativeUrl;
  },
});

function checkIsValid(property, rentalRuleset) {
  const fieldsInError = [];
  if (isNaN(parseInt(property.multi_unit))) fieldsInError.push({ name: 'multi_unit', label: 'Multi-unit mode', required: true });
  if (!property.name) fieldsInError.push({ name: 'name', required: true });
  if (!property.headline.$i18n || !property.headline.$i18n[DEFAULT_LANGUAGE]) fieldsInError.push({ name: 'headline', required: true, localized: true });
  if (!property.summary.$i18n || !property.summary.$i18n[DEFAULT_LANGUAGE]) fieldsInError.push({ name: 'summary', required: true, localized: true });
  if (!property.description.$i18n || !property.description.$i18n[DEFAULT_LANGUAGE]) fieldsInError.push({ name: 'description', required: true, localized: true });
  if (!property.country || !property.country.value[1]) fieldsInError.push({ name: 'country', required: true });
  if (!property.zone || !property.zone.value[1]) fieldsInError.push({ name: 'zone', required: true });
  const areas = (property.areas || []).filter(a => !a.deleted);
  if (areas.length === 0) fieldsInError.push({ name: 'areas', required: true });
  if (!property.main_area || !property.main_area.value[1]) fieldsInError.push({ name: 'main_area', label: 'Main area', required: true });
  if (!property.geoposition) {
    fieldsInError.push({ name: 'geoposition', label: 'Geographic position', required: true });
  } else {
    const positions = property.geoposition.split(',');
    if (positions.length !== 2) {
      fieldsInError.push({ name: 'geoposition', customErrorMessage: 'Geographic position format should be: latitude, longitude' });
    } else {
      const [latitude, longitude] = positions;
      if (isNaN(parseFloat(latitude)) || isNaN(parseFloat(longitude))) {
        fieldsInError.push({ name: 'geoposition', customErrorMessage: 'Geographic position latitude/longitude should be numbers' });
      }
    }
  }
  if (!property.street_address) fieldsInError.push({ name: 'street_address', label: 'Street address', required: true });
  if (!property.postcode) fieldsInError.push({ name: 'postcode', required: true });
  if (!property.locality) fieldsInError.push({ name: 'locality', label: 'Town/City', required: true });
  if (!property.type) fieldsInError.push({ name: 'type', required: true });
  if (!property.surface) fieldsInError.push({ name: 'surface', required: true });
  if (!property.standard_capacity || parseInt(property.standard_capacity) <= 0) fieldsInError.push({ name: 'standard_capacity', label: 'Standard capacity', required: true });
  if (!property.maximum_capacity || parseInt(property.maximum_capacity) <= 0) {
    fieldsInError.push({ name: 'maximum_capacity', label: 'Maximum capacity', required: true });
  } else if (property.maximum_capacity < property.standard_capacity) {
    fieldsInError.push({ name: 'maximum_capacity', customErrorMessage: 'Maximum capacity should be superior to standard capacity' });
  }
  if (isNaN(parseInt(property.nb_bedrooms))) fieldsInError.push({ name: 'nb_bedrooms', label: 'Nb bedrooms', required: true });
  if (isNaN(parseInt(property.nb_bathrooms))) fieldsInError.push({ name: 'nb_bathrooms', label: 'Nb bathrooms', required: true });
  if (isNaN(parseInt(property.floor))) fieldsInError.push({ name: 'floor', required: true });
  if (isNaN(parseInt(property.furniture))) fieldsInError.push({ name: 'furniture', required: true });
  if (!property.pictures || property.pictures.length < 6) fieldsInError.push({ name: 'pictures', customErrorMessage: 'Property should at least have 6 pictures' });
  if ((property.pictures || []).some(p => !p.original || !p.original.value || !p.thumbnail || !p.thumbnail.value)) fieldsInError.push({ name: 'pictures', customErrorMessage: 'Some pictures weren\'t uploaded correctly' });
  if (!rentalRuleset.check_in_out_ruleset || !rentalRuleset.check_in_out_ruleset.value[1]) fieldsInError.push({ name: 'check_in_out_ruleset', label: 'Check in/out ruleset', required: true });
  if (!rentalRuleset.cancellation_policy || !rentalRuleset.cancellation_policy.value[1]) fieldsInError.push({ name: 'cancellation_policy', label: 'Cancellation policy', required: true });
  if (!property.source_channel_id || !property.source_channel_id.value[1]) {
    const hasSeasonalPrices = (rentalRuleset.seasonal_prices || []).filter(p => !p.deleted).length > 0;
    if (!hasSeasonalPrices && (!rentalRuleset.default_price || !rentalRuleset.default_price.base_price || parseInt(rentalRuleset.default_price.base_price) <= 0)) {
      fieldsInError.push({ name: 'default_price.base_price', label: 'Default base price', required: true });
    }
    const hasSeasonalConditions = (rentalRuleset.seasonal_conditions || []).filter(c => !c.deleted).length > 0;
    if (!hasSeasonalConditions && (!rentalRuleset.default_conditions || !rentalRuleset.default_conditions.min_stay || parseInt(rentalRuleset.default_conditions.min_stay) <= 0)) {
      fieldsInError.push({ name: 'default_conditions.min_stay', label: 'Default minimum stay', required: true });
    }
  }
  return fieldsInError;
}

function displayErrorMessage(field) {
  if (field.customErrorMessage) return field.customErrorMessage;
  const fieldName = field.label || field.name.charAt(0).toUpperCase() + field.name.slice(1);
  if (field.required) {
    if (field.localized) {
      return `${fieldName} should at least be informed for language '${DEFAULT_LANGUAGE}'`;
    }
    return `${fieldName} is required`;
  }
}

function submit(props, isValid) {
  props.api.property.setData({ showWarningModal: false });
  const property = props.objectData;
  const active = property.active && isValid;
  const rentalRuleset = props.api.getState('rentalRuleset').objectData;
  const content = props.api.getState('propertyContent').objectData;
  const emailData = props.api.getState('emailPropertyData').objectData;
  props.api.property.setData({ objectData: { ...property, active, synchronisation: null } });
  props.api.rentalRuleset.setData({ objectData: { ...rentalRuleset, synchronisations: null } });
  props.api.property.isSubmittingForm();
  return props.api.rentalRuleset.submitEditForm({ id: rentalRuleset.id, objectData: formatRentalRulesetData(rentalRuleset) })
    .then(() => {
      return Promise.all([
        props.api.property.submitEditForm({ id: property.id, objectData: { ...property, active } }),
        props.api.propertyContent.submitEditForm({ id: content.id, objectData: content }),
        props.api.emailPropertyData.submitEditForm({ id: emailData.id, objectData: emailData }),
      ]);
    })
    .then(() => {
      const errorMessage = props.errorMessage || props.api.getState('rentalRuleset').errorMessage || props.api.getState('propertyContent').errorMessage || props.api.getState('emailPropertyData').errorMessage;
      const successMessage = !errorMessage ? 'Property updated' : null;
      props.api.property.setData({ successMessage, errorMessage });
      return;
    })
    .catch(() => {
      return Promise.all([
        props.api.property.submitEditForm({ id: property.id, objectData: { ...property, active } }),
        props.api.propertyContent.submitEditForm({ id: content.id, objectData: content }),
        props.api.emailPropertyData.submitEditForm({ id: emailData.id, objectData: emailData }),
      ])
      .then(() => {
        const errorMessage = props.errorMessage || props.api.getState('propertyContent').errorMessage || props.api.getState('emailPropertyData').errorMessage;
        const successMessage = !errorMessage ? 'Property updated' : null;
        props.api.property.setData({ successMessage, errorMessage });
        return;
      });
    });
}

function formatRentalRulesetData(rentalRuleset) {
  const { properties, ...data } = rentalRuleset;
  const seasonalPrices = (rentalRuleset.seasonal_prices || []);
  const seasonalConditions = (rentalRuleset.seasonal_conditions || []);
  data.seasonal_prices = seasonalPrices.map(p => ({ $type: 'reference', external: true, value: ['daily_seasonal_prices', p.id], deleted: p.deleted }));
  data.seasonal_conditions = seasonalConditions.map(p => ({ $type: 'reference', external: true, value: ['daily_seasonal_conditions', p.id], deleted: p.deleted }));
  data.relations = {
    daily_seasonal_prices: seasonalPrices.map(p => {
      const { deleted, ...price } = p;
      return price;
    }),
    daily_seasonal_conditions: seasonalConditions.map(c => {
      const { deleted, ...condition } = c;
      return condition;
    }),
  };
  return data;
}



// WEBPACK FOOTER //
// ./src/frontend/modules/inventory/property/containers/EditForm.jsx